module.exports = __webpack_public_path__ + "static/media/posterMobileFirst.fd7dbf32.webp";